import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Paper,
    Popover,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Checkbox,
    Typography,
} from "@mui/material";
import {
    Delete as DeleteIcon,
    Edit,
    Print,
} from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { ToastContainer } from "react-toastify";
import InfiniteScroll from "react-infinite-scroll-component";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Chip } from "@mui/material";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { printPerforma } from "../../Sale/performaPrint";
pdfMake.vfs = pdfFonts.vfs;

const ProSummaryPi = ({ data }) => {
    const truncateText = (text, limit = 20) => {
        if (!text) return "";
        return text.length > limit ? text.substring(0, limit) + "..." : text;
    };

    function formatOnlyDate(dateTimeString, format = "dd-mm-yyyy") {
        const date = new Date(dateTimeString);

        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();

        if (format === "dd-mm-yyyy") {
            return `${day}-${month}-${year}`;
        } else if (format === "yyyy-mm-dd") {
            return `${year}-${month}-${day}`;
        } else {
            throw new Error("Unsupported format. Use 'dd-mm-yyyy' or 'yyyy-mm-dd'.");
        }
    }

    return (
        <>


            <TableContainer
                component={Paper}
                sx={{
                    maxHeight: '48vh', // 👈 yaha height do
                    overflow: "auto",
                }}
            >
                <Table
                    stickyHeader
                    size="small"
                    sx={{
                        minWidth: "max-content",
                        "& td, & th": {
                            borderBottom: "1px solid #ccc",
                            whiteSpace: "nowrap",
                        },
                    }}
                >
                    <TableHead
                        sx={{
                            "& th": {
                                fontWeight: "bold",
                                color: (theme) =>
                                    theme.palette.mode === "dark" ? "#2196f3" : "#333",
                                backgroundColor: (theme) =>
                                    theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                            },
                        }}
                    >
                        <TableRow
                            sx={{
                                backgroundColor: "#f5f5f5",
                                "& th": {
                                    fontWeight: "bold",
                                    color: "#333",
                                    borderBottom: "1px solid #999",
                                    whiteSpace: "nowrap",
                                },
                            }}
                        >

                            <TableCell align="center">S.No.</TableCell>

                            <TableCell
                                sx={{
                                    position: "sticky",
                                    left: 0,
                                    background: "#fff",
                                    zIndex: 3,
                                }}
                                align="center"
                            >
                                PI No.
                            </TableCell>

                            <TableCell align="center">PI Amt</TableCell>
                            <TableCell align="center">Rec Amt</TableCell>
                            <TableCell align="center">Project</TableCell>
                            <TableCell align="center">Date</TableCell>
                            {/* <TableCell>Remarks</TableCell> */}
                            <TableCell
                                align="center"
                                sx={{
                                    position: "sticky",
                                    right: 0,
                                    backgroundColor: "#fff",
                                    zIndex: 3,
                                }}
                            >
                                Action
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Array.isArray(data) &&
                            data.map((invoice, idx) => (
                                <TableRow
                                    key={invoice.invoice_number}
                                    hover
                                    sx={{
                                        backgroundColor: idx % 2 === 0 ? "#fafafa" : "#ffffff",
                                        "&:hover": {
                                            backgroundColor: "#e3f2fd !important",
                                        },
                                        "& td": {
                                            paddingTop: "2px !important",
                                            paddingBottom: "2px !important",
                                            fontSize: { xs: "0.75rem", sm: "0.8125rem" }, // responsive font
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            color: (theme) =>
                                                theme.palette.mode === "dark" ? "white" : "inherit",
                                            backgroundColor: (theme) =>
                                                theme.palette.mode === "dark" ? "black" : "inherit",
                                        },
                                    }}
                                >

                                    <TableCell align="center">{idx + 1}</TableCell>

                                    <TableCell
                                        sx={{
                                            position: "sticky",
                                            left: 0,
                                            background: "#f9f9f9",
                                            zIndex: 1,
                                        }}
                                        align="center"
                                    >
                                        {invoice.pi_no}
                                    </TableCell>

                                    <TableCell align="center">
                                        {Number(invoice.advance_received).toLocaleString(
                                            "en-IN",
                                            {
                                                minimumFractionDigits: 1,
                                                maximumFractionDigits: 1,
                                            }
                                        )}
                                    </TableCell>
                                    <TableCell align="center">
                                        {Number(invoice.receive_amt).toLocaleString(
                                            "en-IN",
                                            {
                                                minimumFractionDigits: 1,
                                                maximumFractionDigits: 1,
                                            }
                                        )}
                                    </TableCell>


                                    <TableCell align="center">
                                        {invoice.project?.project_name || "-"}
                                    </TableCell>
                                    <TableCell align="center">
                                        {formatOnlyDate(invoice.created_at)}
                                    </TableCell>
                                    {/* <TableCell>
                                        <Tooltip title={invoice.remarks} arrow>
                                            <span>{truncateText(invoice.remarks, 20)}</span>
                                        </Tooltip>
                                    </TableCell> */}
                                    <TableCell
                                        sx={{
                                            position: "sticky",
                                            right: 0,
                                            backgroundColor: "#f9f9f9",
                                            zIndex: 1,
                                        }}
                                        align="center"
                                    >
                                      
                                        <IconButton
                                            sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                                            size="small"
                                            onClick={() => printPerforma(invoice)}
                                        >
                                            <Print fontSize="small" />
                                        </IconButton>
                         
                                    </TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
      
    </>
  );
};

export default ProSummaryPi;
